export default __webpack_public_path__ + "static/media/eigthteen.3fda45ec.png";